<a class="btn btn-n1" (click)="clickLink()" [title]="target" [target]="target">
    <span>{{label}}</span>
    <neo-icono [iconoClase]="iconoClase"></neo-icono>
</a>